import * as React from 'react'

function SvgCheckIcon(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 60 60"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.1756 44C29.0134 38.8391 33.1616 35.9628 40 30.7975L39.9959 29.1959C32.7804 23.8018 28.6213 20.9636 21.1809 16L20 17.6692C27.047 22.3704 31.1219 25.1459 37.6531 30.0023C31.4756 34.642 27.3981 37.4559 20.0052 42.3238L21.1756 44Z" />
    </svg>
  )
}

export default SvgCheckIcon
